import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=33540642&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"
import style0 from "./Automation.vue?vue&type=style&index=0&id=33540642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33540642",
  null
  
)

export default component.exports